
















import {
  Component, Vue, Watch, mixins, mapState,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  NewsStore, Payload,
} from '@/state/modules';
import { _isEmpty } from '@samclick-lodash';
import * as appStorageUtil from '@/utils/localstorage-util';

class NewsBannersState {
  public isBannerClosed : boolean = false
}

  @Component({
    /**
     * Imported components
     * */
    components: {},
    /**
     * Stores values
     * */
    computed: {
      ...mapState({
        activeNews: (state: any) => state.news.newsStore.newsBanners,
        isBannerClosed: (state: any) => state.news.newsStore.isBannerClosed,
      }),
    },
    /**
     * Component properties
     * */
    props: {
      showAgree: {
        type: Boolean,
        default: true,
        required: false,
      },
    },
  })
export default class NewsBanners extends mixins(SamclickMixins) {
    /**
     * Local state
     * */
    state = new NewsBannersState();

    /**
     * Watchers
     * */
    @Watch('componentState.var')
    sampleWatcher(newVal: string, oldVal: string) {

    }

    /**
     * Methods
     * */

    dismiss() {
      appStorageUtil.setItem(appStorageUtil.BANNER_IS_CLOSED, true);
      this.state.isBannerClosed = true;
    }

    getActiveNews(language: string) {
      if (!this.isClosed()) {
        appStorageUtil.setItem(appStorageUtil.BANNER_IS_CLOSED, false);
        NewsStore.getActiveNews(new Payload({ language: language }));
      }
    }

    isClosed() {
      return appStorageUtil.getItem(appStorageUtil.BANNER_IS_CLOSED) === 'true';
    }

    /**
     * Computed
     * */


    /**
     * Lifecycle hooks
     * */
    created() {
      this.state.isBannerClosed = this.isClosed();
    }

    mounted() {
        const currentLang = this.$i18n.i18next.language;
        this.getActiveNews(currentLang);

        this.languageChangedHandler = (lng: string) => {
            this.getActiveNews(lng);
        };

        this.$i18n.i18next.on("languageChanged", this.languageChangedHandler);
    }

    beforeDestroy() {
        if (this.languageChangedHandler) {
            this.$i18n.i18next.off("languageChanged", this.languageChangedHandler);
        }
    }


    beforeUpdate() {
    }
}
